// extracted by mini-css-extract-plugin
export default {"root":"SectionTextWithIcons_root__rnnij"};